import { useMutation } from "@tanstack/react-query";
import api from "../services/api";
import { ICheckCloudConnectionPayload } from "./@types";

const useCheckCloudConnection = () => {
  const { mutateAsync: checkCloudConnection } = useMutation({
    mutationFn: async (data: ICheckCloudConnectionPayload) => {
      const fields = Object.keys(data);
      return await api.checkCloudConnection(
        JSON.stringify({
          values: data,
          dirty_fields: fields
        })
      );
    }
  });

  return { checkCloudConnection };
};

export default useCheckCloudConnection;
